import { render, staticRenderFns } from "./StatesIndex.vue?vue&type=template&id=2d7ca6b6&scoped=true&"
import script from "./StatesIndex.vue?vue&type=script&lang=js&"
export * from "./StatesIndex.vue?vue&type=script&lang=js&"
import style0 from "./StatesIndex.vue?vue&type=style&index=0&id=2d7ca6b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7ca6b6",
  null
  
)

export default component.exports